import { en } from './en'
import { fr } from './fr'

export const pollingForm = {
  en,
  fr
}